import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuNovaCotacaoComponent } from './menu-nova-cotacao.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ShowIfAuthorizedModule } from 'src/app/directives/show-if-authorized/show-if-authorized.module'
import { RouterLink } from '@angular/router';
import { TourMatMenuModule, TourStepTemplateComponent } from 'ngx-ui-tour-md-menu';
import { NgIconsModule } from '@ng-icons/core';
import { heroChevronDown } from '@ng-icons/heroicons/outline';
import { heroTruckSolid } from '@ng-icons/heroicons/solid';
import { GaEventModule } from 'src/app/directives/ga-event/ga-event.module';
import { heroGiftMini, heroSparklesMini } from '@ng-icons/heroicons/mini';
import { MenuItemSaudeComponent } from '../menu-item-saude/menu-item-saude.component';

@NgModule({
  declarations: [MenuNovaCotacaoComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MenuItemSaudeComponent,
    MatIconModule,
    ShowIfAuthorizedModule,
    RouterLink,
    TourMatMenuModule,
    NgIconsModule.withIcons({heroChevronDown, heroTruckSolid, heroSparklesMini, heroGiftMini}),
    GaEventModule
  ],
  exports: [MenuNovaCotacaoComponent]
})
export class MenuNovaCotacaoModule { }
